import React from 'react'

const TalkingOutLoudforEveryone = () => {
  return (
    <div>
      <div class="title"><h1>Welcome to JP's Helping Hand</h1></div>
      <div class="main">
        <div class="menubar">
          <ul>
            <li><a href="/">About Us</a></li>
            <li><a href="/TalkingOutLoudforKids">Talking Out loud for Kids</a></li>
            <li><a class="active" href="/TalkingOutLoudforEveryone">Talking Out loud for Everyone</a></li>
            <li><a href="https://docs.google.com/forms/d/e/1FAIpQLSf2f6PIk25F9-VIq4bTU1W9HAklzTdDJsJu6O6O506H-NMLng/viewform?usp=sf_link">Contact US</a></li>
            <li><a href="/PrivacyPolicy">Privacy Policy</a></li>
          </ul>
        </div>

        <h2>Talking Out loud for Everyone</h2>
        <img class="TOLlogo" src="img/TOLElogo.png" width="200" />

        <p>Talking Out Loud for Everyone is an affordable AAC application for disabled people who cannot express themselves verbally created by someone
          who has Cerebral Palsy. TOL helps people say what they are feeling and their wants. They can say what they want to eat, drink, go, or do.
          They also can say when something hurts. They can personalize each page with their favorite foods, places, or the things they like to do the most.
          TOL is also for hospital patients who cannot communicate verbally and allows them to tell what hurts. Talking Out Loud for Everyone also allows
          the user to talk free. The user can have a conversation with others by saying "hi, how are you? My name ..." TOL allows those who cannot speak
          to have a voice. And now users can use TOL to talk with Alexa and Google Assistant enabled devices to ask to play some music or check the
          weather outside. It is up to the user what to ask and each phrase can be saved.</p>
      {/* <!--<p>-->

      <!--  <h4>Talking Out Loud for Everyone now works with Alexa and Google Assistant</h4>-->
      <!--</p>--> */}

        <div class="sreshts">
          <h3>Screenshots:</h3>
          <div class="row">
            <div class="column">
              <img src="img/TOLEScreenshot%20(1).png" style={{ width: "90%" }} />
            </div>
            <div class="column">
              <img src="img/TOLEScreenshot%20(2).png" style={{ width: "90%" }} />
            </div>
            <div class="column">
              <img src="img/TOLEScreenshot%20(3).png" style={{ width: "90%" }} />
            </div>
            <div class="column">
              <img src="img/TOLEScreenshot%20(4).png" style={{ width: "90%" }} />
            </div>
          </div>
        </div>
        <p>
          Download it now on Windows 10 devices, iPads, or Android tablets.
        </p>
        <p>
          <a href='//www.microsoft.com/store/apps/9PG5LMSMW5GW?cid=storebadge&ocid=badge'><img src='img/ms.png' alt='English badge' style={{width: "10%"}}/></a>
          <a href='https://apps.apple.com/us/app/talking-out-loud-for-everyone/id1483405887'><img alt='Get it on the App Store' src='img/app-storee.png' style={{width: "11%"}}/></a>
          <a href='https://play.google.com/store/apps/details?id=com.x.android.talkingoutloudforeveryone'><img alt='Get it on Google Play' src='img/google-play-badge.png' style={{width: "11%"}}/></a>
        </p>
        <p style={{ fontSize: "small" }}>
          Google Play and the Google Play logo are trademarks of Google LLC. <br/>
          Apple, the Apple logo, iPhone, and iPad are trademarks of Apple Inc., registered in the U.S. and other countries and regions. App Store is a service mark of Apple Inc.<br />
          Amazon, Alexa and all related logos are trademarks of Amazon.com, Inc. or its affiliates.

          <br />
          <br />
          Alexa and Google Assistant enabled devices are sold separately.
        </p>
      </div>
    </div>
  )
}

export default TalkingOutLoudforEveryone